module.exports = __webpack_public_path__ + "static/media/exchange_succes.60adc581.png";